import { Box } from '@mui/material';

import styles from './styles';

export default function Container({ children }: { children: React.ReactNode }) {
  return <Box sx={styles.container}>{children}</Box>;
}
